import { SubjectType } from '@/resource/subject/subject.model';

const getLevelsBySubjectType = (
  subjectType: SubjectType,
  isNoLevel = false,
) => {
  const availLevels: number[] = [];

  //NOTE: -1 is for chapter elementary, -2 for lowerform, -3 for upperform
  if (subjectType === SubjectType.LowerForm) {
    if (!isNoLevel) {
      availLevels.push(...[7, 8, 9]);
    } else {
      availLevels.push(...[-2]);
    }
  } else if (subjectType === SubjectType.UpperForm) {
    if (!isNoLevel) {
      availLevels.push(...[10, 11]);
    } else {
      availLevels.push(...[-3]);
    }
  } else if (subjectType === SubjectType.Elementary) {
    availLevels.push(...[1, 2, 3, 4, 5, 6]);
    // if (!isNoLevel) {
    //   availLevels.push(...[1, 2, 3, 4, 5, 6]);
    // } else {
    //   availLevels.push(...[-1]);
    // }
  }

  return availLevels;
};

export default getLevelsBySubjectType;
